<template>
  <div id="navigational-aids-layer">
  </div>
</template>

<script>
import {createNamespacedHelpers} from "vuex";
import mapboxgl from "mapbox-gl";
import {NavigationsMixin} from "@/mixins";

// Store
const {
  mapActions: mapActionsOfLiveMap,
  mapState: mapStateOfLiveMap
} = createNamespacedHelpers("liveMap");

export default {
  name: "NavigationalAidsLayer",
  mixins: [NavigationsMixin],
  data() {
    return {
      layersMinZoom: 5,
      navigationalAidsSourceId: "navigationalAidsSource",
      navigationalAidsLighthouseLayerId: "navigationalAidsLighthouseLayer",
      navigationalAidsLightBuoyLayerId: "navigationalAidsLightBuoyLayer",
      navigationalAidsLightBeaconLayerId: "navigationalAidsLightBeaconLayerId",
      navigationalAidsOtherLayerId: "navigationalAidsOtherLayer",
      beforeLayerId: 'PlotTextLayer',
    };
  },
  props: {
    map: Object,
    isReady: {type: Boolean, default: false},
    mapEvent: String
  },
  computed: {
    ...mapStateOfLiveMap({
      filterNavigations: state => state.filterNavigations
    })
  },
  watch: {
    async isReady() {
      if (this.isReady) {
        await this.setNavigationalAidsSource()
        await this.setNavigationalAidsLayers()
        this.setVisibility()
      }
    },
    filterNavigations() {
      if (this.isReady) {
        this.setVisibility()
      }
    }
  },
  methods: {
    ...mapActionsOfLiveMap([]),
    setVisibility() {
      if (this.filterNavigations.find(el => el === String(this.navigationsCategory.LIGHTHOUSE))) {
        this.map.setLayoutProperty(this.navigationalAidsLighthouseLayerId, 'visibility', 'visible');
      } else {
        this.map.setLayoutProperty(this.navigationalAidsLighthouseLayerId, 'visibility', 'none');
      }
      if (this.filterNavigations.find(el => el === String(this.navigationsCategory.LIGHT_BUOY))) {
        this.map.setLayoutProperty(this.navigationalAidsLightBuoyLayerId, 'visibility', 'visible');
      } else {
        this.map.setLayoutProperty(this.navigationalAidsLightBuoyLayerId, 'visibility', 'none');
      }
      if (this.filterNavigations.find(el => el === String(this.navigationsCategory.LIGHT_BEACON))) {
        this.map.setLayoutProperty(this.navigationalAidsLightBeaconLayerId, 'visibility', 'visible');
      } else {
        this.map.setLayoutProperty(this.navigationalAidsLightBeaconLayerId, 'visibility', 'none');
      }
      if (this.filterNavigations.find(el => el === String(this.navigationsCategory.OTHER))) {
        this.map.setLayoutProperty(this.navigationalAidsOtherLayerId, 'visibility', 'visible');
      } else {
        this.map.setLayoutProperty(this.navigationalAidsOtherLayerId, 'visibility', 'none');
      }
    },
    async setNavigationalAidsSource() {
      this.map.addSource(this.navigationalAidsSourceId, {
        type: "vector",
        url: "mapbox://aidea.navigational_aids?fresh=true"
      });
    },
    async setNavigationalAidsLayers() {
      // 灯台
      this.map.addLayer({
        id: this.navigationalAidsLighthouseLayerId,
        type: "symbol",
        minzoom: this.layersMinZoom,
        source: this.navigationalAidsSourceId,
        "source-layer": "lighthouse",
        layout: {
          "icon-image": "navi-lighthouse",
          "visibility": "none",
        },
      }, this.beforeLayerId)
      this.cratePopup(this.navigationalAidsLighthouseLayerId)

      // 灯浮標
      this.map.addLayer({
        id: this.navigationalAidsLightBuoyLayerId,
        type: "symbol",
        minzoom: this.layersMinZoom,
        source: this.navigationalAidsSourceId,
        "source-layer": "light_buoy",
        layout: {
          "icon-image": "navi-light-buoy",
          "visibility": "none",
        },
      }, this.beforeLayerId)
      this.cratePopup(this.navigationalAidsLightBuoyLayerId)

      // 灯標
      this.map.addLayer({
        id: this.navigationalAidsLightBeaconLayerId,
        type: "symbol",
        minzoom: this.layersMinZoom,
        source: this.navigationalAidsSourceId,
        "source-layer": "light_beacon",
        layout: {
          "icon-image": "navi-light-beacon",
          "visibility": "none",
        },
      }, this.beforeLayerId)
      this.cratePopup(this.navigationalAidsLightBeaconLayerId)

      // その他
      this.map.addLayer({
        id: this.navigationalAidsOtherLayerId,
        type: "symbol",
        minzoom: this.layersMinZoom,
        source: this.navigationalAidsSourceId,
        "source-layer": "other",
        layout: {
          "icon-image": "navi-other",
          "visibility": "none",
        },
      }, this.beforeLayerId)
      this.cratePopup(this.navigationalAidsOtherLayerId)
    },

    cratePopup(layerId) {
      let popup = new mapboxgl.Popup({
        closeButton: false,
        closeOnClick: false
      });
      let self = this
      this.map.on('mouseenter', layerId, function (e) {
        self.map.getCanvas().style.cursor = 'pointer';
        let coordinates = e.features[0].geometry.coordinates.slice();
        let html = self.crateHtml(e.features[0].properties);
        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
          coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
        }
        popup
          .setLngLat(coordinates)
          .setHTML(html)
          .setMaxWidth("220px")
          .addTo(self.map);
      });
      this.map.on('mouseleave', layerId, function () {
        self.map.getCanvas().style.cursor = '';
        popup.remove();
      });
    },

    crateHtml(props) {
      return `<div id="navigational-aids-popup-container">
<div id="item-time"><span class="aisea-text-12-700-black">航路標識</span></div>
<div id="item-navigational-aids-name-val"><span class="aisea-text-12-400-black">航路標識名: ${props.name_jp}</span></div>
<div id="item-navigational-aids-year-val"><span class="aisea-text-12-400-black">データ年度: ${props.year}</span></div>
<div id="item-navigational-aids-informant-val"><span class="aisea-text-12-400-black">出典・情報提供者: ${props.informant}</span></div>
              </div>`
    }
  }
};
</script>

<style lang="scss">
</style>
